// Import and register all your controllers

import { application } from "./application"

// Import controllers
import EchartController from "./echart_controller"
import HelloController from "./hello_controller"
import VisibilityController from "./visibility_controller"
import Clipboard from "@stimulus-components/clipboard"

// Register controllers
application.register("echart", EchartController)
application.register("hello", HelloController)
application.register("visibility", VisibilityController)
application.register("clipboard", Clipboard)
